import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

const formatINR = (n) => `₹${Math.round(n || 0).toLocaleString("en-IN")}`;

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/admin/stats");
        setStats(data);
      } catch {}
    })();
  }, []);

  if (!stats) return <p className="text-[#7A7A7A]" data-testid="admin-dash-loading">Loading dashboard…</p>;

  const cards = [
    { label: "Revenue", value: formatINR(stats.revenue_inr) },
    { label: "Paid Orders", value: stats.paid_orders },
    { label: "Total Orders", value: stats.total_orders },
    { label: "Products", value: stats.product_count },
    { label: "Customers", value: stats.customer_count },
  ];

  return (
    <div data-testid="admin-dashboard">
      <div className="flex items-baseline justify-between mb-8">
        <div>
          <p className="text-[11px] uppercase tracking-nav text-[#5C1A1B]">Overview</p>
          <h1 className="font-serif text-4xl">Atelier Dashboard</h1>
        </div>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-4">
        {cards.map((c) => (
          <div key={c.label} className="bg-white p-6 border border-black/5" data-testid={`stat-${c.label}`}>
            <p className="text-[11px] uppercase tracking-nav text-[#7A7A7A]">{c.label}</p>
            <p className="font-serif text-3xl mt-2 text-[#1A1A1A]">{c.value}</p>
          </div>
        ))}
      </div>

      <div className="mt-10 bg-white p-6 border border-black/5">
        <p className="text-[11px] uppercase tracking-nav text-[#5C1A1B] mb-4">Top Sellers</p>
        {stats.top_products.length === 0 ? (
          <p className="text-sm text-[#7A7A7A]">No orders yet.</p>
        ) : (
          <ul className="divide-y divide-black/5">
            {stats.top_products.map((p) => (
              <li key={p.name} className="py-3 flex items-center gap-4">
                <img src={p.images?.[0]} alt="" className="w-12 h-14 object-cover" />
                <p className="flex-1 font-serif text-lg">{p.name}</p>
                <p className="text-sm font-mono-alt">{p.sold} sold</p>
                <p className="text-sm font-mono-alt">{formatINR(p.price_inr)}</p>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
